import {NumericFormat} from 'react-number-format';
import {forwardRef} from 'react';

export const NumberFormatCustom = forwardRef(function NumberFormatCustom(props, ref) {
    const {onChange, name, ...other} = props;
    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name,
                        value: values.value, // valor “puro” sem formatação
                    },
                });
            }}
            thousandSeparator="." // separador de milhar
            decimalSeparator="," // separador decimal
            prefix="R$ " // prefixo
            decimalScale={2} // sempre 2 casas decimais
            fixedDecimalScale // força mostrar as duas casas
            allowNegative={false}
        />
    );
});
